
// animations/hover-animations.ts
import gsap from 'gsap';
import {
  baseExpand,
  baseShrink,
  baseSkew,
  baseRotate,
  baseMove,
  baseTwist,
  baseFade,
} from './common-base-animations';
import { cleanup, makeHoverTween } from './dot-cms-aniamtion.helper';
import { AnimationDynamicSettings, AnimationType } from './animation/animations.model';

export const hoverAnimations: Partial<
  Record<AnimationType, (s: AnimationDynamicSettings, el: Element, opts?: gsap.TweenVars) => gsap.core.Tween>
> = {
  'hover-expand': (s, el, opts) => {
    // Kill any existing tweens on this element to avoid conflicts
    gsap.killTweensOf(el);
    cleanup(el)

    return makeHoverTween(el, () =>
      baseExpand(el, {
        fromScale: 1, // start at normal size
        scale: s.scale, // hover target scale
        duration: s.duration,
        ease: s.easing,
        overwrite: 'auto', // allow kill overwriting conflicting tweens
        delay: s.delay,
        ...opts,
      })
    );
  },

  'hover-shrink': (s, el, opts) =>
    makeHoverTween(el, () =>
      baseShrink(el, {
        fromScale: 1, // start at normal size
        scale: s.scale, // hover target scale
        duration: s.duration,
        ease: s.easing,
        overwrite: 'auto', // allow kill overwriting conflicting tweens

        delay: s.delay,
        ...opts,
      })
    ),

  'hover-skew': (s, el, opts) =>
    makeHoverTween(el, () =>
      baseSkew(el, {
        fromScale: 1, // start at normal size
        skewX: s.angle ?? 15,
        duration: s.duration,
        ease: s.easing,
        overwrite: 'auto', // allow kill overwriting conflicting tweens

        delay: s.delay,
        ...opts,
      })
    ),

  'hover-rotate': (s, el, opts) =>
    makeHoverTween(el, () =>
      baseRotate(el, {
        rotation: '+=360',
        duration: s.duration,
        ease: s.easing,
        overwrite: 'auto', // allow kill overwriting conflicting tweens

        delay: s.delay,
        ...opts,
      })
    ),

  'hover-move': (s, el, opts) =>
    makeHoverTween(el, () => {
      const rad = ((s.angle ?? 0) * Math.PI) / 180;
      const dist = s.distance ?? 40;
      return baseMove(el, {
        x: Math.cos(rad) * dist,
        y: Math.sin(rad) * dist,
        duration: s.duration,
        ease: s.easing,
        overwrite: 'auto', // allow kill overwriting conflicting tweens

        delay: s.delay,
        ...opts,
      });
    }),

  'hover-twist': (s, el, opts) =>
    makeHoverTween(el, () =>
      baseTwist(el, {
        rotation: s.angle ?? 180,
        scale: s.scale ?? 1,
        duration: s.duration,
        ease: s.easing,
        overwrite: 'auto', // allow kill overwriting conflicting tweens

        delay: s.delay,
        ...opts,
      })
    ),

  'hover-fade': (s, el, opts) =>
    makeHoverTween(el, () =>
      baseFade(el, {
        hoverOpacity: s.opacity ?? 0.3,
        duration: s.duration ?? 0.3,
        ease: s.easing ?? 'power1.inOut',
        overwrite: 'auto', // allow kill overwriting conflicting tweens

        delay: s.delay ?? 0,
        ...opts,
      })
    ),

  // 'hover-appear': (s, el, opts) =>
  //   makeHoverTween(el, () =>
  //     baseAppear(el, {
  //       duration: s.duration,
  //       ease: s.easing,
  //       overwrite: 'auto', // allow kill overwriting conflicting tweens

  //       delay: s.delay,
  //       ...opts,
  //     })
  //   ),

  // 'hover-appear': (s, el, opts) =>
  //   makeHoverTween(el, () =>
  //     baseAppear(el, {
  //       duration: s.duration ?? 0.3,
  //       ease: s.easing ?? 'power1.inOut',
  //       overwrite: 'auto',
  //       delay: s.delay ?? 0,
  //       ...opts,
  //     })
  //   ),

  // 'hover-color': (s, el, opts) =>
  //   makeHoverTween(el, () =>
  //     baseHover(el, {
  //       color: s.fillColor,
  //       duration: s.duration,
  //       ease: s.easing,
  //       overwrite: 'auto', // allow kill overwriting conflicting tweens

  //       delay: s.delay,
  //       ...opts,
  //     })
  //   ),

  
};
